export default __webpack_public_path__ + "static/media/movieAlt.947644df.png";